import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import BrandLogo from "../components/BrandLogo";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (admin && admin !== false) nav("/admin/dashboard", { replace: true });
  }, [admin, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) {
      toast.success("Welcome back, Admin.");
      nav("/admin/dashboard", { replace: true });
    } else {
      toast.error(r.error || "Login failed.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream container-px py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="mx-auto w-14 h-14 rounded-2xl bg-white shadow-premium flex items-center justify-center mb-5 border border-black/5">
            <BrandLogo compact imageClassName="w-9 h-9" />
          </div>
          <div className="overline mb-2">Admin console</div>
          <h1 className="font-heading text-3xl md:text-4xl font-light text-ink">Sign in</h1>
          <p className="mt-2 text-sm text-ink-muted">For Oswal Sabha council members only.</p>
        </div>

        <form onSubmit={submit} className="card-premium space-y-4" data-testid="admin-login-form">
          <div>
            <label className="block text-sm font-medium text-ink-soft mb-2">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-premium"
              placeholder="admin@oswalsabha.org"
              data-testid="admin-login-email-input"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-ink-soft mb-2">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-premium pr-12"
                placeholder="••••••••"
                data-testid="admin-login-password-input"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-ink-muted hover:text-ink transition"
              >
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="admin-login-submit-btn">
            {busy ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in…</> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
